
import { defineComponent, ref, reactive, toRefs, onMounted, watch, computed, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      pagination1: {},
      data: [],
      columns: [],
      spinning: true,
      pagination: false,
      total: 0
    })
    pageData.pagination1 = computed(() => {
      return {
        total: pageData.total,
        showSizeChanger: true,
        showTotal: (total: any) => `共${pageData.total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: changesize,
        onShowSizeChange: changesize
      }
    })
    pageData.columns = [
      {
        title: '解禁时间',
        dataIndex: 'time',
        key: 'time',
        width: '100px'
      },
      {
        title: '解禁数量(股)',
        dataIndex: 'LiftNum',
        key: 'LiftNum',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占总股本比例',
        dataIndex: 'CoverTotalRatio',
        key: 'CoverTotalRatio',
        width: '100px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '占总流通股本比例',
        dataIndex: 'CoverCirculateRatio',
        key: 'CoverCirculateRatio',
        width: '120px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '股票类型',
        dataIndex: 'StockType',
        key: 'StockType',
        width: '200px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      }
    ]
    const route = useRoute()
    function getData(PageID: number, PageSize: number) {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        PageID: PageID,
        PageSize: PageSize
      }
      data.headers = {
        token: props.token
      }
      f10Api.getholderliftdetail(data).then((res: any) => {
        const data = JSON.parse(JSON.stringify(res.Data))
        if ((data.Detail || []).length) {
          data.Detail.forEach((item: any, i: number) => {
            item.index = 'LiftBan' + i
            item.time = item.LiftData ? window.moment(item.LiftData * 1000).format('YYYY-MM-DD') : '—'
          })
        }
        pageData.data = data.Detail
      })
    }
    getData(1, 10)
    function changesize(PageID: any, PageSize: any) {
      getData(PageID, PageSize)
      const dom: any = document.querySelector('.wrapper')
      const offsettop: any = document.getElementById('xsjj')?.offsetTop
      dom.scrollTop = offsettop
    }
    watch(
      () => ((props || {}).pageSourceData || {}).LiftBan || [],
      (val: any) => {
        if (val.length > 10) {
          pageData.pagination = pageData.pagination1
        } else {
          pageData.pagination = false
        }
        nextTick(() => {
          pageData.spinning = false
        })
      },
      { deep: true }
    )

    return {
      ...toRefs(pageData)
    }
  }
})
